export default class ObjectIdGenerator {
  /** @returns {string} */
  create = () => {};
}
